import styled from 'styled-components';
import { colors, s4 } from '@ardoq/design-tokens';
import { GroupSubLabelWrapper, GroupSubLabelText } from './atoms';
import { ItemLabelPopoverContent } from '../../types';
import { TEXT_2_BOLD_REACT_STYLE } from '../consts';
import React from 'react';
import { GroupSubLabel } from './GroupSubLabel';

const ItemLabelPopoverComponentNameLabel = styled.span`
  color: ${colors.grey950};
  white-space: normal;
  overflow-wrap: anywhere;
  padding-right: ${s4};
  max-width: 100%;
`;
const PopoverInner = styled.div`
  max-width: 340px;
  display: flex;
  flex-wrap: wrap;

  ${GroupSubLabelWrapper} {
    overflow-wrap: anywhere;
    white-space: normal;
    display: inline;
    min-width: fit-content;
  }

  ${GroupSubLabelText} {
    display: inline;
  }
`;
export const ItemLabelPopoverContentRenderer = ({
  mainLabel,
  subLabel,
}: ItemLabelPopoverContent) => (
  <PopoverInner>
    <ItemLabelPopoverComponentNameLabel
      style={subLabel ? TEXT_2_BOLD_REACT_STYLE : undefined}
    >
      {mainLabel}
    </ItemLabelPopoverComponentNameLabel>
    {subLabel ? <GroupSubLabel groupSublabel={subLabel} /> : null}
  </PopoverInner>
);
